const baseUserUrl = function (sandBox) {
  if (sandBox) {
    return "https://user.testing.mysabay.com/api/v1.5/";
  } else {
    return "https://user.mysabay.com/api/v1.5/";
  }
};

const baseStoreUrl = function (sandBox) {
  if (sandBox) {
    return "https://store.testing.mysabay.com/api/v1.7/";
  } else {
    return "https://store.mysabay.com/api/v1.7/";
  }
};

const login = function (sandBox) {
  return baseUserUrl(sandBox) + "user/login";
};

const verify = function (sandBox) {
  return baseUserUrl(sandBox) + "user/verify_code";
};

const loginMySabay = function (sandBox) {
  return baseUserUrl(sandBox) + "user/mysabay/login?provider=sabay";
};

const profile = function (sandBox) {
  return baseUserUrl(sandBox) + "user/profile";
};

const refreshToken = function (sandBox) {
  return baseUserUrl(sandBox) + "user/refresh/token";
};

const verifyToken = function (sandBox) {
  return baseUserUrl(sandBox) + "user/verify/token";
};

const logout = function (sandBox) {
  return baseUserUrl(sandBox) + "user/logout";
};

const storeItems = function (sandBox) {
  return baseStoreUrl(sandBox) + "store";
};

const cashiers = function (sandBox) {
  return baseStoreUrl(sandBox) + "cashier";
};

const requestOneTimePayment = function (sandBox) {
  return baseStoreUrl(sandBox) + "charge/onetime";
};

const preAuthProviders = function (sandBox) {
  return baseStoreUrl(sandBox) + "checkout";
};

const payPreAuthProviders = function (sandBox) {
  return baseStoreUrl(sandBox) + "charge/auth";
};

const endPoint = {
  login,
  verify,
  loginMySabay,
  profile,
  refreshToken,
  verifyToken,
  logout,
  storeItems,
  cashiers,
  requestOneTimePayment,
  preAuthProviders,
  payPreAuthProviders,
};

const Utils = {
  endPoint,
};

module.exports = { Utils };
